import { render, staticRenderFns } from "./MessageTimelineItem.vue?vue&type=template&id=58ee20eb&scoped=true&"
import script from "./MessageTimelineItem.vue?vue&type=script&lang=js&"
export * from "./MessageTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee20eb",
  null
  
)

export default component.exports